"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _OzCard = _interopRequireDefault(require("./../OzCard/OzCard.js"));

var _consts = require("./../consts.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzColorpicker__Wrapper",
  componentId: "sc-1g8u298-0"
})(["\n  text-align: left;\n\n  &, & * {\n    box-sizing: border-box;\n  }\n"]);

var Container = _styledComponents.default.div.withConfig({
  displayName: "OzColorpicker__Container",
  componentId: "sc-1g8u298-1"
})(["\n  position: relative;\n"]);

var Active = _styledComponents.default.div.withConfig({
  displayName: "OzColorpicker__Active",
  componentId: "sc-1g8u298-2"
})(["\n  width: ", ";\n  height: ", ";\n  border-radius: 40px;\n  border: 1px solid #CBCBCB;\n  box-shadow: inset 0px 1px 2px #687FE262;\n  cursor: pointer;\n  background-color: ", ";\n\n  &:hover{\n    border: 2px solid ", ";\n  }\n"], function (props) {
  return props.height;
}, function (props) {
  return props.height;
}, function (props) {
  return props.color;
}, _consts.CHETWODEBLUE);

var Options = _styledComponents.default.div.withConfig({
  displayName: "OzColorpicker__Options",
  componentId: "sc-1g8u298-3"
})(["\n  display: ", ";\n  position: absolute;\n  top: -50px;\n  left: 58px;\n  width: 166px;\n  z-index: 3;\n"], function (props) {
  return props.open ? "block" : "none";
});

var Arrow = _styledComponents.default.div.withConfig({
  displayName: "OzColorpicker__Arrow",
  componentId: "sc-1g8u298-4"
})(["\n\n  position: absolute;\n  top: 53px;\n  left: -20px;\n  width: 20px;\n  height: 42px;\n  overflow: hidden;\n\n  &:after{\n    position: absolute;\n    top: 10px;\n    right: -8px;\n    content: \"\";\n    display: block;\n    width: 16px;\n    height: 16px;\n    transform: rotate(45deg);\n    z-index: 9;\n    background: #ffffff;\n    box-shadow: 4px 6px 16px #C1CCE838;\n  }\n"]);

var OptionsWrapper = _styledComponents.default.div.withConfig({
  displayName: "OzColorpicker__OptionsWrapper",
  componentId: "sc-1g8u298-5"
})(["\n  margin-left: -3px;\n  margin-right: -3px;\n"]);

var Option = _styledComponents.default.div.withConfig({
  displayName: "OzColorpicker__Option",
  componentId: "sc-1g8u298-6"
})(["\n  display: inline-block;\n  width: 22px;\n  height: 22px;\n  border-radius: 4px;\n  background-color: ", ";\n  margin: 3px;\n  cursor: pointer;\n"], function (props) {
  return props.color;
});

var ClickCatcher = _styledComponents.default.div.withConfig({
  displayName: "OzColorpicker__ClickCatcher",
  componentId: "sc-1g8u298-7"
})(["\n  display: ", ";\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n"], function (props) {
  return props.open ? "block" : "none";
});

var Label = _styledComponents.default.div.withConfig({
  displayName: "OzColorpicker__Label",
  componentId: "sc-1g8u298-8"
})(["\n  margin-top: 20px;\n  margin-bottom: 5px;\n  font-size: 11px;\n  font-weight: 300;\n"]);

var COLORS = ["#A03587", "#EF5A8E", "#FFA8CE", "#F1CBFF", "#2F6F01", "#0BA04B", "#D1F470", "#48FF95", "#001D5D", "#0982AF", "#74EAFF", "#00B5FF", "#FFF25A", "#CCA949", "#FF963C", "#FFDB89"];

var ColorPicker = function ColorPicker(_ref) {
  var label = _ref.label,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? "transparent" : _ref$value,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "34px" : _ref$height,
      _ref$colors = _ref.colors,
      colors = _ref$colors === void 0 ? COLORS : _ref$colors,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      onChange = _ref.onChange;

  var _useState = (0, _react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var setColor = (0, _react.useCallback)(function (color) {
    onChange(color);
  }, [onChange]);
  return __jsx(Wrapper, null, label ? __jsx(Label, null, label, " ", required ? "*" : "") : null, __jsx(Container, null, __jsx(Active, {
    height: height,
    color: value,
    onClick: function onClick() {
      return setIsOpen(true);
    }
  }), isOpen ? __jsx(Options, {
    open: isOpen
  }, __jsx(Arrow, null), __jsx(_OzCard.default, {
    headerLeft: "Select a color"
  }, __jsx(OptionsWrapper, null, colors.map(function (color, i) {
    return __jsx(Option, {
      onClick: function onClick() {
        return setColor(color);
      },
      color: color,
      key: i
    });
  })))) : null), __jsx(ClickCatcher, {
    open: isOpen,
    onClick: function onClick() {
      return setIsOpen(false);
    }
  }));
};

var _default = ColorPicker;
exports.default = _default;